import React, { useState, useRef, useEffect, useCallback } from "react";
import Header from "../../components/shared/Header";
import AboutUs from "./AboutUs";
import Hero from "./Hero";
import OurFeatures from "./OurFeatures";
import Roadmap from "./Roadmap";
import Footer from "../../components/shared/Footer";

import ScrollHijackContainer from "../../components/ScrollHijackContainer";
import Loader from "../../components/shared/Loader";
import { AssetLoader } from "../../components/shared/AssetLoader";

// Hero
import hero_character from "../../assets/videos/hero-character.webm";
import ImgLightHero from "../../assets/images/light-hero.svg";
import ImgHeroCloud1 from "../../assets/images/hero-cloud-1.svg";
import ImgHeroCloud2 from "../../assets/images/hero-cloud-2.svg";
import ImgMagicIcon from "../../assets/images/magic-icon.png";
import ImgMcpIcon from "../../assets/images/mcp-icon.png";
import ImgShieldIcon from "../../assets/images/shield-icon.png";
import ImgChatIcon from "../../assets/images/chat-icon.png";

// Our Features
import ImgJaggedLine from "../../assets/images/jagged-line.svg";
import ImgMixerThunder from "../../assets/images/mixer-thunder.svg";
import ImgMixerPipe from "../../assets/images/mixer-pipe.png";
import ImgMixerCoin from "../../assets/images/mixer-coin.png";
import ImgLightMixer from "../../assets/images/light-mixer.svg";
import ImgPromptOff from "../../assets/images/prompt-off.png";
import ImgPromptOn from "../../assets/images/prompt-on.png";
import ImgPromptCloud1 from "../../assets/images/prompt-cloud-1.svg";
import ImgPromptCloud2 from "../../assets/images/prompt-cloud-2.svg";
import ImgLightPromptify from "../../assets/images/light-promptify.svg";

// About Us
import ImgAboutUsCloud from "../../assets/images/about-us-cloud.svg";
import ImgStormCharacter from "../../assets/images/storm-character.png";
import ImgLightMcp from "../../assets/images/light-mcp.svg";
import ImgGears from "../../assets/images/gears.png";
import ImgMcpLines from "../../assets/images/mcp-lines.png";

const preloadImage = (src) => {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.src = src;
        img.onload = resolve;
        img.onerror = reject;
    });
};

const criticalAssets = [
	hero_character,
	ImgLightHero,
	ImgHeroCloud1,
	ImgHeroCloud2,
	ImgMagicIcon,
	ImgMcpIcon,
	ImgShieldIcon,
	ImgChatIcon,
	ImgJaggedLine,
	ImgMixerThunder,
	ImgMixerPipe,
	ImgMixerCoin,
	ImgLightMixer,
	ImgPromptOff,
	ImgPromptCloud1,
	ImgPromptCloud2,
	ImgLightPromptify,
	ImgAboutUsCloud,
	ImgStormCharacter,
	ImgLightMcp,
	ImgGears,
	ImgMcpLines,
];

export default function Home() {
	const [lockPoint, setLockPoint] = useState(99999); // Start high to avoid premature lock
	const [isLocked, setIsLocked] = useState(false);
	const [lockScrollUp, setLockScrollUp] = useState(false);
	const [lockScrollDown, setLockScrollDown] = useState(true);
	const [position, setPosition] = useState(0);

	const roadmapRef = useRef(null);

	const onLockStatusChange = useCallback((locked) => {
		if (locked) {
			setTimeout(() => setIsLocked(true), 800);
		} else {
			setIsLocked(false);
		}
	}, []);

	useEffect(() => {
		// preload ImgPromptOn
		preloadImage(ImgPromptOn);

		const calculateLockPoint = () => {
			if (roadmapRef.current) {
				// setLockPoint will be the top of the Roadmap component
				const roadmapLayoutBottom =
					roadmapRef.current.querySelector(".roadmap-layout")
						.offsetTop +
					roadmapRef.current.querySelector(".roadmap-layout")
						.offsetHeight;

				// lockpoint = when bottom of the Roadmap Layout reached 90% of the viewport height
				setLockPoint(roadmapLayoutBottom - window.innerHeight * 0.9);
			}
		};

		// Calculate on initial load
		calculateLockPoint();

		// Calculate lock point every 500ms
		const calculateLockPointInterval = setInterval(calculateLockPoint, 500);

		// Recalculate on window resize
		window.addEventListener("resize", calculateLockPoint);

		// Cleanup the event listener
		return () => {
			clearInterval(calculateLockPointInterval);
			window.removeEventListener("resize", calculateLockPoint);
		};
	}, []); // Empty dependency array means this runs once on mount

	return (
		<AssetLoader assets={criticalAssets}>
			{(allAssetsLoaded) => (
				<>
					<Loader loading={!allAssetsLoaded} />
					<ScrollHijackContainer
						lockPoint={lockPoint}
						onPositionChange={setPosition}
						onLockStatusChange={setIsLocked}
						lockScrollUp={lockScrollUp}
						lockScrollDown={lockScrollDown}
						isLoading={!allAssetsLoaded}
					>
						<Header />
						<Hero />
						<OurFeatures position={position} />

				<AboutUs position={position} />

				<Roadmap
					ref={roadmapRef}
					isLocked={isLocked}
					setLockScrollUp={setLockScrollUp}
					setLockScrollDown={setLockScrollDown}
				/>

				<Footer />

				{/* Uncomment for debugging lock point */}
				{/* <div
					className="debug-element"
					style={{
						width: "100%",
						height: "2px",
						backgroundColor: "rgba(255, 0, 0, 0.5)",
						position: "absolute",
						top: `${lockPoint}px`,
						left: "0",
						zIndex: "1000",
					}}
				></div> */}
					</ScrollHijackContainer>
				</>
			)}
		</AssetLoader>
	);
}
